module.exports = __webpack_public_path__ + "static/media/Example of Locations.1d6f51aa.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Locations.csv
// module id = 694
// module chunks = 0